import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReadingSettingsDataService } from './reading-settings-data.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private httpClient: HttpClient, private readingSettingsData: ReadingSettingsDataService) { }
  getLanguages() {
    return this.httpClient.get(this.readingSettingsData.getSchoolDomain() + "/website/Language/getLanguages")
  }
}